// Simple API response cache for GET requests
const cache = new Map();
const CACHE_DURATION = 30000; // 30 seconds

export const getCachedResponse = (key) => {
  const cached = cache.get(key);
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.data;
  }
  return null;
};

export const setCachedResponse = (key, data) => {
  cache.set(key, { data, timestamp: Date.now() });
};

export const clearCache = (keyPrefix = null) => {
  if (keyPrefix) {
    for (const key of cache.keys()) {
      if (key.startsWith(keyPrefix)) {
        cache.delete(key);
      }
    }
  } else {
    cache.clear();
  }
};

// Clear cache on mutations
export const invalidateCache = () => {
  cache.clear();
};
